import React, { useState, useEffect,useRef } from 'react';
import './FAQ.css';
import Wave from '../Asset/svgviewer-png-output.png';
import icon1 from '../Asset/Vector 7.png';
import arrowBottom from '../Asset/Arrow 6.png';

const OfficePackagePolicyFAQ = () => {
  const [faqs] = useState([
    {
      question: "Q1. What types of offices are eligible for an Office Package Policy?",
      answer: (
        <>
         An Office Package Policy typically covers:

      
      <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• Commercial Offices:</span> Corporate headquarters, administrative offices.
      
      <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• Government Offices:</span> Local, state, and federal offices.
       
      <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• Software Development Offices:</span> IT companies, tech startups.
        
      <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• ITES and BPO Call Centre Offices: </span>Information Technology Enabled Services, Business Process Outsourcing centers.

        </>
      )
    },
    {
      question: "Q2. What are the salient features of an Office Package Policy?",
      answer: (
        <>
       An Office Package Policy shields your office against risks like 
       <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>fire, theft, vandalism, </span>and other potential threats to the premises.
      It also cover losses from employee dishonesty, such as theft or misuse of official data.
      It provides coverage for business interruptions caused by incidents like fires or natural disasters, compensating for lost income and related expenses.
      Moreover, the policy protects against financial losses from third-party claims, including bodily injury or property damage claims related to business operations.
       </>
      )
    },
    {
      question: "Q3. What assets are typically covered under an Office Package Policy?",
      answer:(
        <>
       
     
     <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• Office Buildings:</span> Coverage for the physical structure and its fixtures.
     <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• Electronic Equipment:</span> Computers, servers, and other technological devices.
     <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• Documents and Records:</span> Goods held for sale or used in business operations.
     <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• Stock and Inventory:  </span>Information Technology Enabled Services, Business Process Outsourcing centers.
     <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• Fixtures and Fittings:</span>Permanent installations such as lighting and plumbing.
    </>
      )
      },

      {
        question: "Q4. How long does it usually take to process a claim?",
        answer:(
          <>
        Generally, claims are processed within a few days to a few weeks <span style={{ color: "#F37435", fontWeight: "700" }} >once all necessary information and documentation have been submitted to the insurer.</span>
        Factors that influence the processing time include how complex the claim is, the extent of damage or loss, and the insurer's internal procedures for reviewing and approving claims.
        Providing complete and accurate information promptly can help fasten the claim processing timeline.
        </>
        )
        },
    {
      question: "Q5. What documents are typically required to file a claim?",
      answer: (
        <>
        To file a claim under an Office Package Policy, you may need the following documents:
        <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• Company Registration Documents:</span> Proof of the company's legal registration.
        <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• Business Ownership Documents or Proof of Lease: </span>Ownership documents for the business premises or proof of lease agreement.
        <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• Bank Statements, Tax Returns, or Income Statements: </span>Financial documents to verify business income and expenses.
        <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• List of Business Inventory:</span> Detailed inventory of equipment, supplies, or other assets requiring coverage under the policy.
        <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• Employee Information: </span>Details about employees relevant to the claim.
        <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• Previous Insurance Records:</span> Details of previous insurance policies relevant to the claim.
        </>
      )
      
    
    },
    {
      question: "Q6. Are there specific maintenance requirements to keep an Office Package Policy valid?",
      answer: (
        <>
          Yes, maintaining certain standards and practices is often necessary to ensure the validity of an Office Package Policy. These requirements may include:

          <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• Regular Inspections:</span> Regularly check your office for potential dangers or risks.
          <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• Safety Measures:</span> Ensuring that safety equipment such as fire alarms, sprinkler systems, and extinguishers are in working order and compliant with regulations.
          <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• Building Maintenance: </span>Keeping the office building and its infrastructure well-maintained, including roofs, walls, and electrical systems.
          <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• Security Protocols:</span> Implementing and maintaining security measures to prevent theft or vandalism, such as secure locks and surveillance systems.
          <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• Compliance with Regulations:</span> Sticking to local building codes, fire safety regulations, and other legal requirements relevant to the operation of the office.
          <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• Prompt Repairs: </span>Addressing any damages or defects promptly to prevent further deterioration or risks.
        </>
      )
      
    },
    {
      question: "Q7. What steps should I take in the event of an incident to ensure my claim is successful?",
      answer: (
      
       <>
       After an incident, immediately report it to your insurer and document the damage with photos.
       Secure the property to prevent further loss and gather receipts and invoices as evidence.
       <span style={{ color: "#F37435", fontWeight: "700" }} >Complete the claim form accurately and cooperate with your insurer, </span>keep detailed records, and follow up regularly for a smoother claims process.
        </>

      )
      
    },
    {
      question: "Q8. How does the office package policy differ from other policies?",
      answer: (
        <>
          An Office Package Policy combines multiple types of coverage tailored for office environments into one convenient plan. <span style={{ color: "#F37435", fontWeight: "700" }} >It covers essentials like property damage, liability, and business interruption,</span> along with assets such as office buildings, contents, and electronic equipment. This combination simplifies insurance management, potentially saving costs compared to separate policies.
        </>
      )
        
    },
    {
      question: "Q9. Does the policy cover temporary office setups?",
      answer: 
      (
        <>
         Most Office Package Policies <span style={{ color: "#F37435", fontWeight: "700" }} >can cover temporary office setups, but it's important to confirm with your insurer. Coverage typically extends to both permanent and temporary locations, ensuring flexibility for businesses that may relocate or operate from multiple sites.</span> Always verify specific coverage details to ensure temporary setups are protected under the policy.
        </>
      )
    },
    {
        question: "Q10. How does the policy handle partial damage or loss?",
        answer: 
        (
          <>
           If only part of your insured property is damaged or lost, <span style={{ color: "#F37435", fontWeight: "700" }} >the policy covers the cost to repair or replace that specific portion. The reimbursement is based on the extent of the damage compared to the total insured value of the property. </span>Make sure to report any partial damage immediately and provide documentation to ensure your claim is processed smoothly.
          </>
        )
      },
   
  ]);

  const [visible, setVisible] = useState(false);
  const [buttonClicked, setButtonClicked] = useState(false);
  const [selectedFaqIndex, setSelectedFaqIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  const faqContainerRef = useRef(null);

 const toggleVisibility = () => {
    if (window.pageYOffset > 100 && !buttonClicked) {
      setVisible(true);
    } else if (window.pageYOffset <= 100) {
      setVisible(false);
      setButtonClicked(false); // Allow the button to reappear once the user scrolls back to the top
    }
  };

  const scrollToTop = (e) => {
    e.preventDefault(); // Prevent the default anchor click behavior
    console.log(visible); // Log current state
    setVisible(false); // Hide the button immediately when clicked
    setButtonClicked(true); // Mark the button as clicked
  };

  useEffect(() => {
    if (!visible && buttonClicked) {
      console.log(visible); // Log updated state
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }, [visible, buttonClicked]);

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, [buttonClicked]);



  
  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

//   const handleFaqClick = (index) => {
//     setSelectedFaqIndex(selectedFaqIndex === index ? null : index);
//   };
const handleFaqClick = (index) => {
    if (isMobile) {
      setSelectedFaqIndex(selectedFaqIndex === index ? null : index);
    } else {
      setSelectedFaqIndex(index);
    }
  };
  const handleClickOutside = (event) => {
    if (faqContainerRef.current && !faqContainerRef.current.contains(event.target)) {
      setSelectedFaqIndex(null);
    }
  };

  useEffect(() => {
    if (isMobile) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMobile]);

  return (
    <div>
      <div className='qa-section'>
        <img src={Wave} alt="Wave" className='waveimg' />
        <div ref={faqContainerRef} className={`faq-ct ${isMobile ? 'mobile' : ''}`}>
          <div className="ct box">
            <div className="ct2">
              <h2 style={{ color: "#F37435", fontWeight: "700" }}>FAQ</h2>
              <p style={{ fontSize: "20px", fontWeight: "400", marginTop: '2rem' }}>Frequently Asked Questions</p>
            </div>
            <div className="subct">
              <ul style={{ listStyleType: "none", padding: 0 }}>
                {faqs.map((faq, index) => (
                  <li
                    className={`ct3 ${selectedFaqIndex === index ? "highlighted" : ""} ${isMobile ? "highlighted" : ""}`}
                    key={index}
                    onClick={() => handleFaqClick(index)}
                  >
                    <div className='faq-question'>
                      <strong className='view'>{faq.question}</strong>
                      <img src={icon1} className="side-arrow" alt="sideicon" />
                    </div>
                    {isMobile && (
                      <span className={`arrow ${selectedFaqIndex === index ? "expanded" : ""}`}></span>
                    )}
                    {isMobile && selectedFaqIndex === index && (
                      <div className="subcon1 mobile-subcon">
                        <p>{faq.answer}</p>
                      </div>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          {!isMobile && selectedFaqIndex !== null && (
            <div className="con">
              <div className="subcon">
                <p>{faqs[selectedFaqIndex].question}</p>
              </div>
              <div className="subcon1">
                <p>{faqs[selectedFaqIndex].answer}</p>
              </div>
            </div>
          )}
        </div>
        {visible && (
          <a
            href="#"
            id="scroll"
            onClick={scrollToTop}
            // style={styles.scroll}
            
          >
            <img src={arrowBottom} id="arrowsign" alt="Scroll to top"  />
          </a>
        )}
      </div>
    </div>
  );
};

const styles = {
  scroll2: {
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    right: '5%',
    bottom: '10rem',
    // right: '2%',
    // bottom: '1rem',
    cursor: 'pointer',
    width: '71px',
    height: '71px',
    backgroundColor: 'white',
    borderRadius: '60px',
    zIndex: '1000',
    justifyContent: 'center',
    // boxShadow: '0px 10px 26px rgba(0, 109, 141, 0.2)', 
    boxShadow: '0px 1px 16px rgba(0, 109, 141, 0.25)',
  },
 

  
 span: {
    display: 'block'
  }

};



export default OfficePackagePolicyFAQ;